import * as api from "../api/index";
import * as endpoints from "../api/endpoints";
import * as types from "./mutation-types";

const actions = {
  getScales({ commit }, payload) {
    return api.fetchFull(endpoints.SCALES, payload, commit, (response) => {
      commit(types.SET_SCALES, response.data);
      return response;
    });
  },

  getScaleHouses({ commit }, payload) {
    return api.fetchFull(
      endpoints.SCALE_HOUSES,
      payload,
      commit,
      (response) => {
        commit(types.SET_SCALE_HOUSES, response.data);
        return response;
      }
    );
  },

  getScaleMeasurement({ commit }, payload) {
    const scaleUuid = payload?.scale_uuid || "";
    const requestPayload = { ...(payload || {}) };
    delete requestPayload.scale_uuid;

    if (!scaleUuid) {
      commit(types.SET_SCALE_MEASUREMENTS, { data: [] });
      return Promise.resolve({ data: { data: [] } });
    }

    return api.fetchFull(
      endpoints.SCALE_MEASUREMENT + "/" + scaleUuid,
      requestPayload,
      commit,
      (response) => {
        const measurements = Array.isArray(response?.data?.data)
          ? response.data.data
          : Array.isArray(response?.data)
            ? response.data
            : [];

        commit(types.SET_SCALE_MEASUREMENTS, { data: measurements });
        return response;
      }
    );
  },

  getWeighingOnScale({ commit }, payload) {
    return api.fetchFull(
      endpoints.WEIGHING_ON_SCALE,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  getWeighingOnScaleByUuid({ commit }, payload) {
    return api.fetchFull(
      endpoints.WEIGHING_ON_SCALE + "/show/" + payload.uuid,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  getVehicleConfigurations({ commit }, payload) {
    return api.fetchFull(
      endpoints.WEIGHING_VEHICLE_CONF,
      payload,
      commit,
      (response) => {
        commit(types.SET_VEHICLE_CONFIGURATIONS, response.data);
        return response;
      }
    );
  },

  getWeighingOnScaleTypes({ commit }, payload) {
    return api.fetchFull(
      endpoints.WEIGHING_TYPES,
      payload,
      commit,
      (response) => {
        commit(types.SET_WEIGHING_TYPES, response);
        return response;
      }
    );
  },

  getWeighingOnScaleAutocompleteData({ commit }, payload) {
    return api.fetchFull(
      endpoints.WEIGHING_AUTOCOMPLETE_DATA,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  createWeighingOnScale({ commit }, payload) {
    return api.post(
      endpoints.WEIGHING_ON_SCALE,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  createScale({ commit }, payload) {
    return api.post(endpoints.SCALES, payload, commit, (response) => {
      return response;
    });
  },

  createScaleHouse({ commit }, payload) {
    return api.post(endpoints.SCALE_HOUSES, payload, commit, (response) => {
      return response;
    });
  },

  updateWeighingOnScale({ commit }, payload) {
    return api.put(
      endpoints.WEIGHING_ON_SCALE + "/" + payload.uuid,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  updateScale({ commit }, payload) {
    return api.put(
      endpoints.SCALES + "/" + payload.uuid,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  updateScaleHouse({ commit }, payload) {
    return api.put(
      endpoints.SCALE_HOUSES + "/" + payload.uuid,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  deleteWeighingOnScale({ commit }, payload) {
    return api.remove(
      endpoints.WEIGHING_ON_SCALE + "/" + payload.uuid,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  deleteScale({ commit }, payload) {
    return api.remove(
      endpoints.SCALES + "/" + payload.uuid,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  deleteScaleHouse({ commit }, payload) {
    return api.remove(
      endpoints.SCALE_HOUSES + "/" + payload.uuid,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  downloadPdf({ commit }, payload) {
    return api.downloadBlob(
      payload.url,
      payload,
      payload.type || 'pdf',
      commit,
      (response) => response.data
    );
  },

  getExportInfo({ commit }, payload) {
    return api.fetchFull(payload.url, payload, commit, (response) => {
      return response;
    });
  },
};

export default actions;
